@if (notificationInitialized) {
    <div class="course-notification">
        <div [ngClass]="isUnseen() ? 'is-unseen' : ''" class="course-notification-wrap">
            @if (isShowClose()) {
                <div class="course-notification-close" (click)="closeClicked()">
                    <fa-icon [icon]="faTimes" />
                </div>
            }

            @if (isRedirectToUrl() && notificationUrl) {
                <a class="course-notification-redirect-link" [routerLink]="notificationUrl.link" [queryParams]="notificationUrl.queryParams"></a>
            }

            <div class="course-notification-background"></div>

            <div class="course-notification-icon-wrap">
                @if (isShowProfilePicture) {
                    <jhi-profile-picture
                        [isBoxShadow]="true"
                        imageSizeInRem="2.5"
                        fontSizeInRem="1.1"
                        [authorId]="authorId"
                        [authorName]="authorName"
                        [imageUrl]="addPublicFilePrefix(authorImageUrl)"
                    />
                } @else {
                    <div class="course-notification-icon">
                        <fa-icon [icon]="faIcon" />
                    </div>
                }
            </div>

            <div class="course-notification-content-wrap w-100">
                <strong [jhiTranslate]="'artemisApp.courseNotification.' + notificationType + '.title'" [translateValues]="notificationParameters"></strong>
                <div
                    class="course-notification-content"
                    [jhiTranslate]="'artemisApp.courseNotification.' + notificationType + '.content'"
                    [translateValues]="notificationParameters"
                ></div>
            </div>

            @if (!isHideTime()) {
                <div class="course-notification-date">
                    <span [jhiTranslate]="notificationTimeTranslationKey" [translateValues]="notificationTimeTranslationParameters"></span>
                </div>
            }

            @if (displayTimeInMilliseconds() !== undefined) {
                <div [ngStyle]="{ 'animation-duration': displayTimeInMilliseconds() + 'ms' }" class="course-notification-loading-indicator"></div>
            }
        </div>
    </div>
}
